<div class="skeleton-panel" role="status" aria-live="polite" [attr.aria-label]="'Loading ' + entityLabel">
  <aside class="skeleton-sidebar">
    @for (section of sidebarSections; track section.title) {
      <div class="skeleton-section">
        <div class="skeleton-section-title">{{ section.title }}</div>
        @for (field of section.fields; track field) {
          <div class="skeleton-field">
            <span class="skeleton-label">{{ field }}</span>
            <span class="skeleton-bar skeleton-bar-dark"></span>
          </div>
        }
      </div>
    }
  </aside>

  <main class="skeleton-main">
    <header class="skeleton-header">
      <span class="skeleton-bar skeleton-title"></span>
      <span class="skeleton-bar skeleton-pill"></span>
      <button type="button" class="skeleton-close" (click)="closeRequested.emit()" aria-label="Close">
        <mat-icon>close</mat-icon>
      </button>
    </header>

    <section class="skeleton-block">
      <div class="skeleton-heading">Description</div>
      <span class="skeleton-bar skeleton-textarea"></span>
    </section>

    <nav class="skeleton-tabs">
      @for (tab of tabs; track tab; let first = $first) {
        <span class="skeleton-tab" [class.active]="first">{{ tab }}</span>
      }
    </nav>

    <section class="skeleton-block">
      <div class="skeleton-heading">{{ infoTitle }}</div>
      <div class="skeleton-info-grid">
        @for (field of infoFields; track field) {
          <div class="skeleton-field">
            <span class="skeleton-label skeleton-label-light">{{ field }}</span>
            <span class="skeleton-bar"></span>
          </div>
        }
      </div>
    </section>
  </main>
</div>
